import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

import {
  db,
} from "../firebase";

import {
  collection,
  query,
  where,
  onSnapshot,
  doc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";

import "../styles/RideRequests.css";

export default function RideRequests() {

  const { user } = useAuth();

  const [rides, setRides] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    if (!user) return;

    const q = query(
      collection(db, "rideRequests"),
      where("driverUid", "==", user.uid),
      where("status", "==", "pending")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {

      const list = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      setRides(list);

      setLoading(false);

    });

    return unsubscribe;

  }, [user]);

  async function acceptRide(id) {

    try {

      await updateDoc(doc(db, "rideRequests", id), {

        status: "accepted",

        acceptedAt: serverTimestamp(),

      });

      alert("Ride Accepted");

    }

    catch (err) {

      console.error(err);

      alert(err.message);

    }

  }

  async function rejectRide(id) {

    try {

      await updateDoc(doc(db, "rideRequests", id), {

        status: "rejected",

      });

      alert("Ride Rejected");

    }

    catch (err) {

      console.error(err);

      alert(err.message);

    }

  }

  if (loading)
    return <h3 style={{textAlign:"center"}}>Loading...</h3>;

  return (

    <div className="ride-page">

      <h2>🚖 Ride Requests</h2>

      {rides.length === 0 && (

        <div className="empty-rides">

          No pending ride requests.

        </div>

      )}

      {rides.map((ride) => (

        <div
          key={ride.id}
          className="ride-card"
        >

          <h3>{ride.customerName}</h3>

          <p>

            <strong>📞</strong>

            {" "}

            {ride.customerMobile}

          </p>

          <p>

            <strong>📍 Pickup</strong>

            {" "}

            {ride.pickup}

          </p>

          <p>

            <strong>🏁 Destination</strong>

            {" "}

            {ride.destination}

          </p>

          {ride.notes && (

            <p>

              <strong>📝 Notes</strong>

              {" "}

              {ride.notes}

            </p>

          )}

          <div className="ride-buttons">

            <button
              className="accept-btn"
              onClick={() => acceptRide(ride.id)}
            >

              ✅ Accept

            </button>

            <button
              className="reject-btn"
              onClick={() => rejectRide(ride.id)}
            >

              ❌ Reject

            </button>

          </div>

        </div>

      ))}

    </div>

  );

}